import { IsOptional, IsString } from 'class-validator';
import { UIAddress } from '../addresses/browser.types';
import {
	ChargebeePlans,
	ChargebeePlansV2,
	ChargebeeSubscriptionStatus
} from '../chargebee/chargebee.enums';
import { AccountCategory, AccountUsage } from './accounts.enums';

export interface SRAccount {
	id: number;
	name: string;
	address: UIAddress;
	category: AccountCategory;
	usage: AccountUsage;
	createdAt: string;
	deactivatedAt: Date | null;
	maxActiveUsers: number;
	maxActiveCustomers: number;
	maxActiveProperties: number;
	apiAccessToken: string;
	externalProfileRadius?: number;
	plan: ChargebeePlans | ChargebeePlansV2;
	activePlanUntil: Date;
	subscriptionStatus: ChargebeeSubscriptionStatus;
}

export interface StateAndCityCounts {
	[x: string]: {
		count: number;
		cities?: {
			[x: string]: number | undefined;
		};
	};
}

export class CreateOAuthClientRequestDTO {
	@IsString()
	name: string;

	@IsOptional()
	@IsString()
	scopes?: string;
}

export class OAuthClientResponseDTO {
	id: number;
	clientId: string;
	name: string;
	scopes: string;
	isActive: boolean;
	lastUsedAt: Date | null;
}

export class CreateOAuthClientResponseDTO extends OAuthClientResponseDTO {
	clientSecret: string;
}
